// extracted by mini-css-extract-plugin
module.exports = {"icon":"_02712f2b3b--icon--ZEVKF"};